import NotFoundImage from "../assets/icons/404.svg";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <img src={NotFoundImage} alt="" className=" w-60" />
      <p className="text-sm text-white my-4">Page not found</p>
    </div>
  );
};

export default NotFound;
